import * as React from 'react';
import {Group, Title, Button} from '@mantine/core';
import { FaPlus } from 'react-icons/fa';

interface SimpleHeaderProps{
    title : string;
    right?: any;
    button?: { title: string; onClick: any };
}

export default function SimpleHeader(props : SimpleHeaderProps){
    const {title, button, right} = props;
    return <Group position="apart" mb="md">
        <Title order={2}>{title}</Title>
        <>
            {right ? right
            : button && <Button
                onClick={button.onClick}
                leftIcon={<FaPlus />}
            >{button.title}</Button>}
        </>
    </Group>
}